import styled from 'styled-components';

export const ServicesButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  align-content: center;
  position: relative;
  z-index: 2;
`;
